<script lang="ts">
	import { PodcastPage } from '#lib/websites/talks/pages/PodcastPage/index.js';
</script>

<PodcastPage />
